import { PURCHASER_API_BASE_URL, getHeaders } from "../Constants";

export type RequisitionConfigUser = {
    id: number;
    first_name: string;
    last_name: string;
    email: string;
    iconBackgroundColorClass: string;
};

export type RequisitionConfig = {
    teamId: number;
    allowedInboundEmails: string[];
    assignmentStrategy: "CLAIM" | "ROUND_ROBIN" | "WORKLOAD";
    rfqTemplateId: number | null;
    muteResponses: boolean;
    mailboxName: string;
    autoAssignableUsers: RequisitionConfigUser[];
};

export type UpdateRequisitionConfig = {
    mailboxName?: string;
    allowedInboundEmails?: string[];
    assignmentStrategy?: "CLAIM" | "ROUND_ROBIN" | "WORKLOAD";
    rfqTemplateId?: number | null;
    muteResponses?: boolean;
    autoAssignableUsers?: number[];
};

export const getRequisitionSettings = async (): Promise<RequisitionConfig> => {
    const url = `${PURCHASER_API_BASE_URL}/v2/requisitions/settings`;
    const res = await fetch(url, { headers: getHeaders() });
    if (!res.ok) {
        throw new Error("Failed to fetch requisition settings");
    }
    return (await res.json()) as RequisitionConfig;
};

export const updateRequisitionSettings = async (data: UpdateRequisitionConfig): Promise<RequisitionConfig> => {
    const url = `${PURCHASER_API_BASE_URL}/v2/requisitions/settings`;
    const res = await fetch(url, {
        method: "PATCH",
        headers: getHeaders(),
        body: JSON.stringify(data),
    });
    if (!res.ok) {
        throw new Error("Failed to update requisition settings");
    }
    return (await res.json()) as RequisitionConfig;
};

export default {
    getRequisitionSettings,
    updateRequisitionSettings,
};
